import { AlertContainer, AlertText } from './components';

export const Alert = {
  Container: AlertContainer,
  Text: AlertText,
};
